import React from 'react';
import ReactDOM from 'react-dom';

import { RecentActivity } from './components/RecentActivity';

export const initRecentActivityList = (target) => {
  if (!target) {
    return;
  }

  const activityURL = target.dataset.activityUrl;

  if (!activityURL) {
    return;
  }

  ReactDOM.render(
    <RecentActivity
      activityURL={activityURL}
      componentId={target.dataset.componentId}
      envopsMode={target.dataset.envopsMode === 'true'}
      hideHeader={target.dataset.hideHeader === 'true'}
    />,
    target
  )

}

export { RecentActivity };
